module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/sightseeing_2-a711081c1b23d6c9fadcc14d0f91fca3.jpg";